import { useCallback, useMemo } from "react";

import { cn } from "@/lib/chillnn/cn";

import type * as Model from "../../model";

type Props = {
	recommendedTagList: Model.Type.ViewData["recommendedTagList"];
	selectedTagList: Model.Type.ViewModel["selectedTagList"];
	canSelectTag: Model.Type.ViewModel["canSelectTag"];
	onSelectCallback: (tag: string) => void;
};

export const RecommendedTagLabelList = ({
	recommendedTagList,
	selectedTagList,
	canSelectTag,
	onSelectCallback,
}: Props) => {
	const cantSelectTag = useMemo(() => !canSelectTag, [canSelectTag]);

	/**
	 * タグ押下時の処理
	 */
	const handleClickTag = useCallback(
		(value: string) => {
			if (cantSelectTag) return;

			onSelectCallback(value);
		},
		[cantSelectTag, onSelectCallback],
	);

	/**
	 * 選択可能なタグリスト
	 */
	const canSelectTagList = useMemo(
		() => recommendedTagList.filter((tag) => !selectedTagList.includes(tag)),
		[recommendedTagList, selectedTagList],
	);

	return (
		<>
			{canSelectTagList.map((tag, index) => {
				const tagText = `# ${tag}`;

				return (
					<label
						key={index}
						className={cn(
							"inline-block max-w-[max-content] cursor-pointer rounded border border-zinc-100 p-2 text-sm duration-1000 hover:shadow-xl",
							cantSelectTag && " cursor-default hover:shadow-none",
						)}
						onClick={() => handleClickTag(tag)}
					>
						{tagText}
					</label>
				);
			})}
		</>
	);
};
